import apiLogin from '../apiLogin';
import { LoginData } from './types';

export const login = async (data: LoginData) => {
  try {
    const response = await apiLogin.post('/auth/login', data);
    return response.data;
  } catch (error) {
    throw error;
  }
};
